import { createSlice } from "@reduxjs/toolkit";
import { foundationDetailsService } from "Services/FoundationDetailsService";

export const initialState = {
    originalValues: {},
    foundationName: {
        value: '',
        error: ''
    },
    registeredName: {
        value: '',
        error: ''
    },
    otherName: {
        value: '',
        error: ''
    },
    phoneNumber: {
        value: '',
        error: ''
    },
    email: {
        value: '',
        error: ''
    },
    site: {
        value: '',
        error: ''
    },
    address: {
        value: '',
        error: ''
    },
    complement: {
        value: '',
        error: ''
    },
    city: {
        value: '',
        error: ''
    },
    province: {
        value: '',
        error: ''
    },
    postalCode: {
        value: '',
        error: ''
    },
    bn: {
        value: '',
        error: ''
    }   
};

const updateFoundationSlice = createSlice({
    name: "update-foundation-ca",
    initialState,
    reducers: {
        handleChange: (state, action) => {
            state[action.payload.field].error = '';
            state[action.payload.field].value = action.payload.value;            
        },
        handleModelErrors: (state, action) => {
            Object.entries(action.payload).forEach(([field, errors]) => {
                state[field].error = errors[0];
            });
        },

    },
    extraReducers: (builder) => {
        builder.addMatcher(
            foundationDetailsService.endpoints.getFunderForEdit.matchFulfilled, (state, action) => {
                const funder = action.payload;

                const mappedValues = {
                    foundationName: funder.foundationName ?? '',
                    phoneNumber: funder.phone ?? '',
                    email: funder.email ?? '',
                    site: funder.site ?? '',
                    address: funder.address ?? '',
                    city: funder.city ?? '',
                    province: funder.stateOrProvince ?? '',
                    postalCode: funder.zipOrPostalCode ?? '',
                };

                Object.entries(mappedValues).forEach(([field, value]) => {
                    state[field].value = value;
                    state[field].error = '';
                });

                state.bn.value = funder.profileId ?? '';
                state.originalValues = mappedValues;
            }
        )
    },
});

export const {
    handleChange,
    handleModelErrors,
} = updateFoundationSlice.actions;

export default updateFoundationSlice.reducer;